import { Component, OnInit } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';

@Component({
    selector: 'app-walkaround-questions',
    templateUrl: './walkaround-questions.component.html',
    styleUrls: ['./walkaround-questions.component.scss'],
    standalone: false
})
export class WalkaroundQuestionsComponent implements OnInit {

  buttons: GridButton[] = [
    {label: 'Edit', link: '/workshop/walkaround-questions/edit/:id', type: 'btn-warning'} as GridButton,
  ]

  columns: GridColumn[] = [
    {active: true, label: '#', field: 'id'} as GridColumn,
    {active: true, label: 'Question', field: 'checkInformation'} as GridColumn,
    {active: true, label: 'Check Area', field: 'vehicleCheckArea.name'} as GridColumn,
    {active: true, label: 'Severity if failed', field: 'severityDetail.notes'} as GridColumn,
    {active: true, label: 'Vehicle Type', field: 'vehicleTypeId', value: v => v === 0 ? 'All' : v} as GridColumn,
    {active: true, label: 'Takes vehicle off road', field: 'isVor', value: v => v ? 'Yes' : 'No'} as GridColumn,
    {active: true, label: 'Active', field: 'active', value: v => v ? 'Yes' : 'No'} as GridColumn,
  ];

  filters: GridFilter[] = []

  searchFields: any = ['checkInformation'];

  searchFilters: GridSearchFilter[] = [
    {
      field: 'checkInformation',
      label: 'Question',
    } as GridSearchFilter,
  ]

  constructor() { }

  ngOnInit(): void {
  }
}
